import * as React from "react";
import { formatData } from "./helpers";
import moment from "moment";
import { formatDate } from "helpers/formatDate";
import { VerticalCalendar } from "components/design-system/organisms/Calendar";
import LoadingCalendar from "components/design-system/molecules/LoadingCalendar";

import { FeasibleTimeslots, Timeslot } from "types/timeslot";
import { Moment } from "moment";

interface MobileCalendarProps {
  data?: FeasibleTimeslots;
  onNext: (date: Moment) => void;
  onlyDoubleTimeslots: boolean;
  setTimeslot: (timeslot: Timeslot) => void;
  selectedTimeslot: Timeslot;
}

export const MobileCalendar: React.FunctionComponent<MobileCalendarProps> = ({
  data,
  onNext,
  onlyDoubleTimeslots,
  setTimeslot,
  selectedTimeslot,
}) => {
  const datesData = React.useRef([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [dates, setDates] = React.useState([]);

  React.useEffect(() => {
    setIsLoading(true);
    const hasTimeslots = Boolean(data?.timeslots);
    if (hasTimeslots) {
      const filteredTimeslots = data.timeslots.filter(
        (timeslot) => timeslot.total_capacity - timeslot.nb_bookings >= 2
      );
      const timeslots = onlyDoubleTimeslots ? filteredTimeslots : data.timeslots;
      const formattedData = Object.entries(timeslots.reduce(formatData, {})).map(([key, values]) => ({
        timestamp: key,
        displayDate: formatDate(moment.unix(parseInt(key))),
        timeslots: values.sort((timeslotA, timeslotB) => {
          if (timeslotA.end < timeslotB.end) {
            return -1;
          }
          return 1;
        }),
      }));

      formattedData.forEach((data) => {
        if (datesData.current.find((dates) => dates.timestamp === data.timestamp)) {
          return;
        }
        datesData.current = [...datesData.current, data];
      });

      const shouldFetchNextDates = Boolean(data?.next_timeslot && datesData.current.length < 3);

      if (shouldFetchNextDates) {
        const nextStartDate = moment(data.next_timeslot.beginning);
        return onNext(nextStartDate);
      }

      setDates(datesData.current);
      setIsLoading(false);
    }
  }, [data, onNext, onlyDoubleTimeslots]);

  const handleClick = () => {
    const nextStartDate = moment(data.next_timeslot.beginning);
    return onNext(nextStartDate);
  };

  React.useEffect(() => {
    const hasTimeslots = Boolean(data?.timeslots?.length);
    if (data?.next_timeslot && !hasTimeslots) {
      const nextStartDate = moment(data.next_timeslot.beginning);
      return onNext(nextStartDate);
    }
  }, [data, onNext]);

  if (isLoading) {
    return <LoadingCalendar />;
  }
  return (
    <VerticalCalendar
      isLoading={isLoading}
      onSelectTimeslot={setTimeslot}
      onNextPeriod={handleClick}
      selectedTimeslot={selectedTimeslot}
      timeslotsByDay={dates}
      nextTimeslot={data?.next_timeslot}
    />
  );
};
